import { ChannelMember } from '../Types';

export function sortMembers(members: ChannelMember[]): ChannelMember[] {
  return members.slice().sort((a, b) => {
    // Put operators (managers) first
    if (a.role === 'operator' && b.role !== 'operator') return -1;

    if (a.role !== 'operator' && b.role === 'operator') return 1;

    // Then sort by nickname A-Z (case insensitive)
    const nameA = (a.nickname ?? '').toLowerCase();
    const nameB = (b.nickname ?? '').toLowerCase();

    if (nameA < nameB) return -1;

    if (nameA > nameB) return 1;

    return 0;
  });
}
